import UserAgent from './../helpers/UserAgent';

const launcher = (Browser) => {
    document.querySelectorAll('video.custom-video-player').forEach((video) => {
        if (!video.classList.contains('has_poster') && (Browser.isFirefox || Browser.isSafari)) {
            return;
        }

        if (Browser.isSafari) {
            video.preload = 'metadata';
            window.App.siblings(video, '.video_overlay').forEach(el => el.classList.add('pause'));
            return;
        }

        video.oncanplay = () => {
            window.App.siblings(video, '.video_overlay').forEach(el => el.classList.add('pause'));
        };
    });
};

launcher(new UserAgent());


/** @TODO Merge with /modules/video-player */

const siblings = window.App.siblings;
const scrollTop = window.App.scrollTop;

export class Video {
    init() {
        document.querySelectorAll('video.custom-video-player').forEach((player) => {
            // const self = player;
            const video = player;

            const playEventHandler = (event) => {
                siblings(event.target, '.video_overlay').forEach(el => el.classList.remove('pause'));
                siblings(event.target, '.video_poster').forEach(el => el.classList.remove('visible'));

                event.target.classList.add('visible');

                const menu = document.querySelector('body > nav');
                const menuHeight = menu.offsetHeight;

                if (menuHeight <= 0 || window.scrollY >= menuHeight + 50) {
                    return;
                }

                scrollTop(menuHeight, () => {
                    menu.classList.remove('slideDown');
                    menu.classList.add('slideUp');
                }, 100);
            };

            video.addEventListener('play', playEventHandler);
            video.addEventListener('playing', playEventHandler);
            video.addEventListener('click', playEventHandler);

            video.onpause = () => siblings(video, '.video_overlay').forEach(el => el.classList.add('pause'));

            siblings(video, '.video_overlay, .video_poster').forEach(el => el.addEventListener('click', () => video.play()));
        });

        const self = this;

        document.querySelectorAll('.video-player').forEach((element) => {
            element.addEventListener('mouseenter', () => self.play(element))
                .addEventListener('mouseleave', () => self.stop(element));
        });


        window.addEventListener('load', () => {
            const autoplay = document.querySelectorAll('.bg-video');

            if (!autoplay) {
                return;
            }

            const triggers = document.querySelectorAll('.play-video');

            autoplay.forEach(player => player.autoplay = false);
            autoplay.forEach(player => player.play());

            triggers.forEach(el => el.classList.add('playing'));
            const onPlay = (event) => {
                event.target.nextElementSibling.play();
                event.target.classList.add('playing');
                window.App.fadeOut(event.target);
            };

            triggers.forEach(trigger => trigger.addEventListener('click', onPlay));
        });
    }

    play(video) {
        const type = video.dataset.type || null;

        if (type === 'youtube') {
            video.ocontentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (type === 'video') {
            video.play();
        }
    }

    stop(video) {
        const type = video.dataset.type || null;

        if (type === 'youtube') {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (type === 'video') {
            video.pause();
        }
    }
}

(new Video).init();